var swiper = new Swiper(".winner__container", {
  slidesPerView: 3.2,
  navigation: {
    nextEl: ".swiper-button-next-new",
    prevEl: ".swiper-button-prev-new",
  },
  pagination: {
    el: ".swiper-pagination-new",
    clickable: true,
  },
  responsive: [
    {
		  breakpoint: 768,
		  	settings: {
				arrows: false,
				initialSlide: 0,
				slidesToShow: 1,
		  	}
    }
  ],
  breakpoints: {
    320: {
      slidesPerView: 1,
    },
    750: {
        slidesPerView: 3.2,
    }
  },
});
